import { ApolloClient, gql } from "@apollo/client";
import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";

export interface CloudCage {
  cageId: number;
  groupId?: number;
  fallowedSite?: boolean;
  machineId: number;
}

export interface CloudCageGroup {
  id: number;
  name: string;
}

export interface CloudMachine {
  id: number;
  marlinVersion: string;
}

export interface CloudSite {
  id: number;
  name: string;
  timezone: string;
  createdAt: string;
  hardwareVersion?: string;
  machines: CloudMachine[];
  cages: CloudCage[];
  cageGroups: CloudCageGroup[];
}

const GET_SITES = gql`
  query {
    sites {
      id
      name
      timezone
      createdAt
      hardwareVersion
      machines {
        id
        marlinVersion
      }
      cages {
        cageId
        groupId
        fallowedSite
        machineId
      }
      cageGroups {
        id
        name
      }
    }
  }
`;

export interface CloudSitesApi {
  list: ReadOnlyStore<CloudSite[]>;
  refresh(): Promise<CloudSite[]>;
}

export function createCloudSitesApi(
  client: ApolloClient<unknown>,
): CloudSitesApi {
  const store = createStore<CloudSite[]>([]);
  return {
    list: store.store,
    refresh: async () => {
      try {
        const { data } = await client.query<{ sites: CloudSite[] }>({
          query: GET_SITES,
          fetchPolicy: "no-cache",
        });
        const sites = data?.sites ?? [];
        store.set(sites);
        return sites;
      } catch (e) {
        console.warn("[shell] cloud sites query failed", e);
        store.set([]);
        return [];
      }
    },
  };
}
